// JavaScript Document
$(document).ready(function($) {
  var player = new Vimeo.Player($('#movieMain'));
  $("#movieCover").click(function() {
    $("#movieCover").fadeOut();
    player.play();
  });
});
$(function() {
  if ($(window).width() < 769) {
    //for SP
    var h = $(window).height();
    $("#movieImg").css("height", h - 47 + "px");
    $("#movieCover img").css("height", h - 47 + "px");
  } else {
    //for PC
  }
});